"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "optimizeTargetGraph", {
    enumerable: true,
    get: function() {
        return optimizeTargetGraph;
    }
});
const _targetgraph = require("@lage-run/target-graph");
async function optimizeTargetGraph(graph, runnerPicker, createBackCompatGraph) {
    const targetMinimizedNodes = await (0, _targetgraph.removeNodes)([
        ...graph.targets.values()
    ], async (target)=>{
        if (target.type === "noop") {
            return true;
        }
        if (target.id === (0, _targetgraph.getStartTargetId)()) {
            return createBackCompatGraph ? true : false;
        }
        const runner = await runnerPicker.pick(target);
        if (await runner.shouldRun(target)) {
            return false;
        }
        return true;
    });
    if (createBackCompatGraph) {
        return targetMinimizedNodes;
    }
    const reduced = (0, _targetgraph.transitiveReduction)(targetMinimizedNodes);
    // Update the dependents of nodes based on the new set of dependencies
    // first build up a dependency map for quick lookup
    const dependencyMap = new Map();
    for (const node of reduced){
        for (const depId of node.dependencies){
            if (!dependencyMap.has(depId)) {
                dependencyMap.set(depId, new Set());
            }
            dependencyMap.get(depId).add(node.id);
        }
    }
    // update the dependents of each node
    for (const node of reduced){
        const dependents = new Set();
        if (dependencyMap.has(node.id)) {
            dependencyMap.get(node.id).forEach((dependentId)=>dependents.add(dependentId));
        }
        node.dependents = Array.from(dependents);
    }
    return reduced;
}
